import Dashboard from './Dashboard.vue';

export default {
  path: '',
  component: Dashboard,
  name: 'home',
  meta: { auth: true },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/dashboard/rotas.js